import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CourseAssignmentCompletionDocument } from './@types';

export function completeUserCourseAssignments(
   assignee_userid: number,
   documents: CourseAssignmentCompletionDocument[],
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('patch', `/course_assignments/User/completeAll/${assignee_userid}`, {
      ...common,
      body: {
         documents,
      },
   });
}

type CompleteUserCourseAssignmentsErrorCode =
   | 'course_assignments.complete_user.user_not_found'
   | 'course_assignments.complete_user.insufficient_privileges';

completeUserCourseAssignments.errorMessages =
   createErrorMessageTypeGuard<CompleteUserCourseAssignmentsErrorCode>();
